/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Reply_SubmitInputs */

const en_settings_tickets_reply_submit = /** @type {(inputs: Settings_Tickets_Reply_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Reply`)
};

const zh_settings_tickets_reply_submit = /** @type {(inputs: Settings_Tickets_Reply_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送回复`)
};

/**
* | output |
* | --- |
* | "Send Reply" |
*
* @param {Settings_Tickets_Reply_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_reply_submit = /** @type {((inputs?: Settings_Tickets_Reply_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Reply_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_reply_submit(inputs)
	return zh_settings_tickets_reply_submit(inputs)
});
export { settings_tickets_reply_submit as "settings.tickets.reply_submit" }